import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { testDatabase } from './utils/testDatabase';
import { testLogin } from './utils/testLogin';
import { checkRLS } from './utils/checkRLS';

// Make test utilities available globally for debugging
if (typeof window !== 'undefined') {
  window.testDatabase = testDatabase;
  window.testLogin = testLogin;
  window.checkRLS = checkRLS;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

